import gql from 'graphql-tag'
import client from '@stores/apollo'

export default function template(): Promise<string> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: {
            mapping: { operationCostImportTemplateFile },
          },
        },
      },
    }: any) => operationCostImportTemplateFile
  )
}

const query = gql`
  query OperationCostTemplate {
    viewer {
      company {
        mapping {
          operationCostImportTemplateFile
        }
      }
    }
  }
`
